type Props = {
  heading?: string
  helpText?: string
}

export function NoResults(props: Props) {
  return (
    <div className="py-10 flex items-center justify-center gap-4 flex-col">
      <div className="type-title-m-light">{props.heading ? props.heading : "No results found"}</div>
      <div className="type-body-m-serif">{props.helpText ? props.helpText : "Try refining your search terms and filter settings."}</div>
    </div>
  )
}
